<span *ngIf="!isSorted"><i class="pt-1 fas fa-sort p unsorted"></i></span>
<span *ngIf="isSorted && !isDescending" ><i class=" pt-1 fas fa-sort-down sorted"></i></span>
<span *ngIf="isSorted && isDescending"><i class="pt-1 fas fa-sort-up sorted"></i></span>
